import { styled } from 'styled-components';

const StyledCurrencyContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;

	.icon {
		transition:
			filter 0.25s ease,
			opacity 0.25s ease;
		opacity: 0.5;
	}
`;

const StyledLabel = styled.div`
	position: relative;
	font-family: 'GT Walsheim Pro';
	color: #fff;
	font-weight: 700;
	transition: color 0.25s ease;

	${StyledCurrencyContainer}.donate & {
		color: #ffc100;
	}
`;

export { StyledCurrencyContainer, StyledLabel };
